(function () {
  'use strict';

  function initHeader(root) {
    root = root || document;

    var header = root.querySelector
      ? root.querySelector('[data-site-header]')
      : document.querySelector('[data-site-header]');

    if (!header || header.dataset.dkInitialized === 'true') return;
    header.dataset.dkInitialized = 'true';

    var body = document.body;
    var section = header.closest('.shopify-section') || header.parentElement;
    var drawer = document.querySelector('[data-mobile-drawer]');
    var modal = document.querySelector('[data-search-modal]');
    var openers = document.querySelectorAll('[data-mobile-nav-open]');
    var closers = document.querySelectorAll('[data-mobile-nav-close]');

    /* Sticky must be applied to Shopify's section wrapper, not only the
       header element, otherwise the sticky area ends at the section height. */
    if (section) {
      section.classList.toggle(
        'dk-header-section--sticky',
        header.classList.contains('is-sticky')
      );
    }

    function setDrawer(open) {
      if (!drawer) return;
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      body.classList.toggle('dk-menu-open', open);
      openers.forEach(function (button) {
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    function setSearch(open) {
      if (!modal) return;
      modal.classList.toggle('is-open', open);
      modal.setAttribute('aria-hidden', open ? 'false' : 'true');
      body.classList.toggle('dk-menu-open', open);

      if (open) {
        window.setTimeout(function () {
          var input = modal.querySelector('input');
          if (input) input.focus();
        }, 100);
      }
    }

    openers.forEach(function (button) {
      button.addEventListener('click', function () {
        setDrawer(true);
      });
    });

    closers.forEach(function (button) {
      button.addEventListener('click', function () {
        setDrawer(false);
      });
    });

    document.querySelectorAll('[data-mobile-submenu]').forEach(function (button) {
      button.addEventListener('click', function () {
        var item = button.closest('li');
        if (!item) return;
        var open = item.classList.toggle('is-open');
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
        button.textContent = open ? '−' : '+';
      });
    });

    document.querySelectorAll('[data-search-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        setSearch(true);
      });
    });

    document.querySelectorAll('[data-search-close]').forEach(function (button) {
      button.addEventListener('click', function () {
        setSearch(false);
      });
    });

    document.querySelectorAll('[data-search-expand]').forEach(function (wrap) {
      var toggle = wrap.querySelector('[data-search-expand-toggle]');
      var input = wrap.querySelector('[data-search-expand-input]');
      var clear = wrap.querySelector('[data-search-expand-clear]');
      var guard = wrap.querySelector('[data-search-expand-guard]');
      var form = input && input.closest('form');
      if (!toggle || !input) return;

      function syncValueState() {
        wrap.classList.toggle('has-value', input.value.length > 0);
      }

      function setExpand(open) {
        var header = wrap.closest('[data-site-header]');
        var predictive = wrap.querySelector('predictive-search');
        var isMobile = window.matchMedia('(max-width: 989px)').matches;
        wrap.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.setAttribute('aria-label', 'Search');
        if (header) header.classList.toggle('is-mobile-search-open', open && isMobile);
        if (open) {
          window.setTimeout(function () { input.focus(); }, 50);
        } else {
          predictive && predictive.close && predictive.close();
          input.blur();
        }
      }

      syncValueState();
      input.addEventListener('input', syncValueState);
      input.addEventListener('search', syncValueState);

      if (clear) {
        clear.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          input.value = '';
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.focus();
        });
      }

      if (guard) {
        guard.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          setExpand(false);
        });
      }

      toggle.addEventListener('click', function (event) {
        event.stopPropagation();
        if (!wrap.classList.contains('is-open')) {
          setExpand(true);
          return;
        }
        if (window.matchMedia('(max-width: 989px)').matches) {
          setExpand(false);
          return;
        }
        if (input.value.trim() === '') {
          setExpand(false);
        } else if (form) {
          form.submit();
        }
      });

      document.addEventListener('click', function (event) {
        if (!wrap.classList.contains('is-open')) return;
        if (event.target.closest('.dk-ajax-search__form, .dk-ajax-search__results')) return;
        setExpand(false);
      });

      input.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') setExpand(false);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        setDrawer(false);
        setSearch(false);
      }
    });

    var lastY = window.scrollY;
    var ticking = false;

    function updateHeader() {
      var y = Math.max(window.scrollY, 0);
      var scrollingDown = y > lastY;

      header.classList.toggle('is-scrolled', y > 24);

      if (header.classList.contains('hide-on-scroll')) {
        header.classList.toggle('is-hidden', scrollingDown && y > 160);
      } else {
        header.classList.remove('is-hidden');
      }

      lastY = y;
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateHeader);
      },
      { passive: true }
    );

    updateHeader();

    var announcement = document.querySelector('[data-announcement]');
    if (announcement && announcement.dataset.dkInitialized !== 'true') {
      announcement.dataset.dkInitialized = 'true';
      var items = announcement.querySelectorAll('[data-announcement-item]');
      var rotate = announcement.dataset.rotate === 'true';
      var speed = parseInt(announcement.dataset.speed || '5000', 10);
      var index = 0;

      if (rotate && items.length > 1) {
        window.setInterval(function () {
          items[index].classList.remove('is-active');
          index = (index + 1) % items.length;
          items[index].classList.add('is-active');
        }, speed);
      }

      var close = announcement.querySelector('[data-announcement-close]');
      if (close) {
        close.addEventListener('click', function () {
          announcement.hidden = true;
        });
      }
    }
  }

  function init() {
    initHeader(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  /* Re-initialize after a section is re-rendered in Shopify Theme Editor. */
  document.addEventListener('shopify:section:load', function (event) {
    var newHeader = event.target.querySelector('[data-site-header]');
    if (newHeader) {
      newHeader.dataset.dkInitialized = 'false';
      initHeader(event.target);
    }
  });
})();


(function(){
  'use strict';

  function money(cents, format){
    var value=(Number(cents)||0)/100;
    var amount=value.toLocaleString(document.documentElement.lang||'en-US',{minimumFractionDigits:2,maximumFractionDigits:2});
    if(!format) return '$'+amount;
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g,Math.round(value).toLocaleString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g,amount.replace(/,/g,'X').replace('.',',').replace(/X/g,'.'))
      .replace(/\{\{\s*amount\s*\}\}/g,amount);
  }

  function initMiniCart(){
    var root=document.querySelector('[data-mini-cart]');
    if(!root || root.dataset.initialized==='true') return;
    root.dataset.initialized='true';
    var body=document.body;
    var panel=root.querySelector('.dk-mini-cart__panel');
    var items=root.querySelector('[data-mini-cart-items]');
    var empty=root.querySelector('[data-mini-cart-empty]');
    var loading=root.querySelector('[data-mini-cart-loading]');
    var footer=root.querySelector('[data-mini-cart-footer]');
    var scrollBody=root.querySelector('[data-mini-cart-body]');
    var scrollHint=root.querySelector('[data-mini-cart-scroll-hint]');
    var total=root.querySelector('[data-mini-cart-total]');
    var note=root.querySelector('[data-mini-cart-note]');
    var moneyFormat=root.dataset.moneyFormat||'${{amount}}';
    var lastFocus=null;

    function setOpen(open){
      root.classList.toggle('is-open',open);
      root.setAttribute('aria-hidden',open?'false':'true');
      body.classList.toggle('dk-cart-open',open);
      if(open){
        lastFocus=document.activeElement;
        load();
        setTimeout(function(){ var close=root.querySelector('[data-mini-cart-close]'); if(close) close.focus(); },100);
      }else if(lastFocus && lastFocus.focus){ lastFocus.focus(); }
    }

    function updateBadges(count){
      document.querySelectorAll('.dk-header__cart-count').forEach(function(el){
        el.textContent=count;
        el.hidden=count===0;
      });
    }

    function esc(str){
      var div=document.createElement('div');
      div.textContent=str==null?'':String(str);
      return div.innerHTML;
    }

    function updateScrollHint(){
      if(!scrollBody || !scrollHint) return;
      var hasOverflow=scrollBody.scrollHeight>scrollBody.clientHeight+2;
      var atBottom=scrollBody.scrollTop+scrollBody.clientHeight>=scrollBody.scrollHeight-3;
      scrollHint.hidden=!(hasOverflow && !atBottom);
    }

    function render(cart){
      loading.hidden=true;
      updateBadges(cart.item_count||0);
      empty.hidden=cart.item_count>0;
      footer.hidden=cart.item_count===0;
      items.innerHTML='';

      (cart.items||[]).forEach(function(item,index){
        var line=document.createElement('article');
        line.className='dk-mini-cart__item';
        line.dataset.key=item.key;
        var image=item.image?'<a class="dk-mini-cart__item-media" href="'+esc(item.url)+'"><img src="'+esc(item.image)+'&width=180" alt="'+esc(item.product_title)+'" width="180" height="180" loading="lazy"></a>':'<div class="dk-mini-cart__item-media"></div>';
        var variant=(item.variant_title && item.variant_title!=='Default Title')?'<p class="dk-mini-cart__variant">'+esc(item.variant_title)+'</p>':'';
        line.innerHTML=image+
          '<div class="dk-mini-cart__item-info">'+
            '<a class="dk-mini-cart__item-title" href="'+esc(item.url)+'">'+esc(item.product_title)+'</a>'+
            variant+
            '<div class="dk-mini-cart__qty">'+
              '<button type="button" data-cart-minus aria-label="Decrease quantity">−</button>'+
              '<input type="number" min="0" value="'+item.quantity+'" inputmode="none" data-cart-quantity aria-label="Quantity" aria-readonly="true" readonly tabindex="-1">'+
              '<button type="button" data-cart-plus aria-label="Increase quantity">+</button>'+
            '</div>'+
          '</div>'+
          '<div class="dk-mini-cart__item-end">'+
            '<span class="dk-mini-cart__item-price">'+money(item.final_line_price,moneyFormat)+'</span>'+
            '<button type="button" class="dk-mini-cart__remove" data-cart-remove>Remove</button>'+
          '</div>';
        items.appendChild(line);
      });

      if(total) total.textContent=money(cart.total_price,moneyFormat);
      updateProgress(cart.total_price||0);
      requestAnimationFrame(function(){
        if(scrollBody) scrollBody.scrollTop=0;
        updateScrollHint();
      });
    }

    function updateProgress(totalPrice){
      var wrap=root.querySelector('[data-mini-cart-progress-wrap]');
      if(!wrap) return;
      var threshold=Number(root.dataset.freeShippingThreshold||0)||0;
      var text=wrap.querySelector('[data-mini-cart-progress-text]');
      var bar=wrap.querySelector('[data-mini-cart-progress-bar]');
      if(threshold<=0){ wrap.hidden=true; return; }
      wrap.hidden=false;
      var reached=totalPrice>=threshold;
      var remaining=Math.max(threshold-totalPrice,0);
      var before=root.dataset.progressBefore||"You’re [amount] away from free shipping";
      var after=root.dataset.progressAfter||"You’ve unlocked free shipping";
      text.textContent=reached?after:before.replace('[amount]',money(remaining,moneyFormat));
      bar.style.width=Math.min(totalPrice/threshold*100,100)+'%';
    }

    function load(){
      loading.hidden=false;
      fetch(window.Shopify&&Shopify.routes?Shopify.routes.root+'cart.js':'/cart.js',{headers:{Accept:'application/json'}})
        .then(function(r){ if(!r.ok) throw new Error('Cart load failed'); return r.json(); })
        .then(render)
        .catch(function(){ loading.textContent='Unable to load cart. Please try again.'; });
    }

    function change(key,quantity){
      root.classList.add('is-updating');
      fetch(window.Shopify&&Shopify.routes?Shopify.routes.root+'cart/change.js':'/cart/change.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({id:key,quantity:Math.max(0,Number(quantity)||0)})
      }).then(function(r){ if(!r.ok) throw new Error('Cart update failed'); return r.json(); })
        .then(render)
        .finally(function(){ root.classList.remove('is-updating'); });
    }

    if(scrollBody){
      scrollBody.addEventListener('scroll',updateScrollHint,{passive:true});
    }
    window.addEventListener('resize',updateScrollHint,{passive:true});

    document.addEventListener('click',function(e){
      var opener=e.target.closest('[data-mini-cart-open]');
      if(opener){ e.preventDefault(); setOpen(true); return; }
      if(e.target.closest('[data-mini-cart-close]')){ setOpen(false); return; }
      var row=e.target.closest('.dk-mini-cart__item');
      if(!row) return;
      var input=row.querySelector('[data-cart-quantity]');
      if(e.target.closest('[data-cart-minus]')) change(row.dataset.key,Number(input.value)-1);
      if(e.target.closest('[data-cart-plus]')) change(row.dataset.key,Number(input.value)+1);
      if(e.target.closest('[data-cart-remove]')) change(row.dataset.key,0);
    });

    items.addEventListener('change',function(e){
      if(e.target.matches('[data-cart-quantity]')){
        var row=e.target.closest('.dk-mini-cart__item');
        change(row.dataset.key,e.target.value);
      }
    });

    if(note){
      var timer;
      note.addEventListener('input',function(){
        clearTimeout(timer);
        timer=setTimeout(function(){
          fetch(window.Shopify&&Shopify.routes?Shopify.routes.root+'cart/update.js':'/cart/update.js',{
            method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({note:note.value})
          });
        },500);
      });
    }

    document.addEventListener('submit',function(e){
      var form=e.target;
      if(!form || !form.matches('form[action*="/cart/add"]') || form.hasAttribute('data-dk-native-cart')) return;
      if(e.submitter && e.submitter.getAttribute('name')==='checkout') return;
      e.preventDefault();
      var submit=form.querySelector('[type="submit"]');
      if(submit){ submit.disabled=true; submit.classList.add('is-loading'); }

      var formData=new FormData(form);
      var productRoot=form.closest('.dkp2');
      var selectedUpsells=productRoot
        ? productRoot.querySelectorAll('[data-upsell-cart-item][data-variant-id]:checked')
        : [];
      var requestUrl=form.action;
      var requestHeaders={Accept:'application/json'};
      var requestBody=formData;

      /* Add the main product and all selected upsells atomically. Sending
         separate cart mutations can race on slower mobile connections and
         intermittently leave one item out of the cart. */
      if(selectedUpsells.length){
        var mainVariantId=parseInt(formData.get('id'),10);
        var mainQuantity=Math.max(parseInt(formData.get('quantity'),10)||1,1);
        var mainItem={id:mainVariantId,quantity:mainQuantity};
        var properties={};

        formData.forEach(function(value,key){
          var match=key.match(/^properties\[(.+)\]$/);
          if(match && String(value).trim()!=='') properties[match[1]]=value;
        });
        if(Object.keys(properties).length) mainItem.properties=properties;

        var sellingPlan=formData.get('selling_plan');
        if(sellingPlan) mainItem.selling_plan=parseInt(sellingPlan,10)||sellingPlan;

        var cartItems=[mainItem];
        selectedUpsells.forEach(function(input){
          var variantId=parseInt(input.dataset.variantId,10);
          if(variantId) cartItems.push({id:variantId,quantity:1});
        });

        requestUrl=(window.Shopify && Shopify.routes)
          ? Shopify.routes.root+'cart/add.js'
          : '/cart/add.js';
        requestHeaders['Content-Type']='application/json';
        requestBody=JSON.stringify({items:cartItems});
      }

      fetch(requestUrl,{
        method:'POST',
        headers:requestHeaders,
        body:requestBody
      }).then(function(r){
        return r.json().then(function(data){
          if(!r.ok) throw new Error(data.description||'Unable to add this item.');
          return data;
        });
      }).then(function(){
        setOpen(true);
      }).catch(function(error){
        var errorBox=form.querySelector('[data-cart-error]');
        if(errorBox){ errorBox.textContent=error.message; errorBox.hidden=false; }
        else window.alert(error.message);
      }).finally(function(){
        if(submit){ submit.disabled=false; submit.classList.remove('is-loading'); }
      });
    },true);

    document.addEventListener('keydown',function(e){ if(e.key==='Escape') setOpen(false); });
    document.addEventListener('cart:open',function(){ setOpen(true); });
    document.addEventListener('cart:refresh',load);
  }

  function initNewsletter(){
    var root=document.querySelector('[data-newsletter-popup]');
    if(!root || root.dataset.initialized==='true') return;
    root.dataset.initialized='true';
    var preview=root.dataset.preview==='true';
    var frequency=root.dataset.frequency||'7';
    var storageKey='dkNewsletterDismissedAt';
    var last=parseInt(localStorage.getItem(storageKey)||'0',10);
    var now=Date.now();
    var blocked=false;

    if(!preview && last){
      if(frequency==='never') blocked=true;
      else if(frequency==='session') blocked=sessionStorage.getItem(storageKey)==='1';
      else blocked=now-last < Number(frequency)*86400000;
    }
    if(blocked) return;

    function open(){
      root.classList.add('is-open');
      root.setAttribute('aria-hidden','false');
      document.body.classList.add('dk-newsletter-open');
      setTimeout(function(){ var input=root.querySelector('input[type=email]'); if(input) input.focus(); },120);
    }
    function close(){
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden','true');
      document.body.classList.remove('dk-newsletter-open');
      if(frequency==='session') sessionStorage.setItem(storageKey,'1');
      else localStorage.setItem(storageKey,String(Date.now()));
    }

    root.querySelectorAll('[data-newsletter-close]').forEach(function(btn){ btn.addEventListener('click',close); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') close(); });

    if(root.querySelector('[data-newsletter-success]')){
      localStorage.setItem(storageKey,String(Date.now()));
      open();
      return;
    }

    var triggerType = root.dataset.trigger || 'time';
    if (triggerType === 'scroll') {
      var threshold = Math.max(0, Number(root.dataset.scrollDistance) || 0);
      var onScroll = function () {
        if (window.scrollY >= threshold) {
          window.removeEventListener('scroll', onScroll);
          open();
        }
      };
      if (threshold <= 0) {
        open();
      } else {
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }
    } else {
      setTimeout(open, Math.max(0, Number(root.dataset.delay) || 0));
    }
  }

  function initDekorkOverlays(){
    initMiniCart();
    initNewsletter();
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initDekorkOverlays,{once:true});
  else initDekorkOverlays();

  document.addEventListener('shopify:section:load',initDekorkOverlays);
})();

/* =========================================================
   V33.32 — Continuous compact room grid
   Builds wall + floor in one responsive SVG so every floor ray
   starts from the exact wall-column position at the meeting line.
   ========================================================= */
(() => {
  const selector = [
    '.dk-mini-cart__item-media',
    '.dk-cart-line__image',
    '.dk-cart__item-media',
    '.cart-item__media',
    '.dk-predictive__media'
  ].join(',');

  const SVG_NS = 'http://www.w3.org/2000/svg';
  const observed = new WeakSet();

  function numberFromCss(value, fallback) {
    const parsed = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function addLine(group, x1, y1, x2, y2) {
    const line = document.createElementNS(SVG_NS, 'line');
    line.setAttribute('x1', x1.toFixed(2));
    line.setAttribute('y1', y1.toFixed(2));
    line.setAttribute('x2', x2.toFixed(2));
    line.setAttribute('y2', y2.toFixed(2));
    group.appendChild(line);
  }

  function renderRoom(media) {
    if (!media || !media.isConnected) return;

    const width = Math.max(1, media.clientWidth);
    const height = Math.max(1, media.clientHeight);
    if (width < 8 || height < 8) return;

    const styles = getComputedStyle(media);
    const globalCell = numberFromCss(styles.getPropertyValue('--dk-product-grid-size'), 50);
    const scale = numberFromCss(styles.getPropertyValue('--dk-cart-media-grid-scale'), .45);
    const cell = Math.max(8, globalCell * scale);
    const horizon = height * .56;
    const center = width / 2;
    const floorHeight = height - horizon;
    const spread = 2.35;

    let svg = media.querySelector(':scope > .dk-compact-room-grid');
    if (!svg) {
      svg = document.createElementNS(SVG_NS, 'svg');
      svg.classList.add('dk-compact-room-grid');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      svg.setAttribute('preserveAspectRatio', 'none');
      media.insertBefore(svg, media.firstChild);
    }

    svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
    svg.replaceChildren();

    const wall = document.createElementNS(SVG_NS, 'g');
    wall.classList.add('dk-compact-room-wall');
    const floor = document.createElementNS(SVG_NS, 'g');
    floor.classList.add('dk-compact-room-floor');

    // Center the wall cells so the room remains visually balanced.
    const firstX = center - Math.ceil(center / cell) * cell;
    for (let x = firstX; x <= width + cell; x += cell) {
      // Wall column and floor ray share the exact same point at the horizon.
      addLine(wall, x, 0, x, horizon);
      const bottomX = center + (x - center) * spread;
      addLine(floor, x, horizon, bottomX, height);
    }

    // Wall rows stop just above the meeting line; no artificial horizon stroke.
    for (let y = horizon - cell; y > 0; y -= cell) {
      addLine(wall, 0, y, width, y);
    }

    // Perspective floor rows become progressively farther apart toward the viewer.
    const rowCount = Math.max(4, Math.min(9, Math.round(floorHeight / Math.max(10, cell * .72))));
    for (let i = 1; i <= rowCount; i += 1) {
      const t = i / (rowCount + .25);
      const y = horizon + floorHeight * Math.pow(t, 1.72);
      addLine(floor, 0, y, width, y);
    }

    svg.append(wall, floor);
  }

  function setup(media) {
    if (observed.has(media)) {
      renderRoom(media);
      return;
    }
    observed.add(media);
    renderRoom(media);

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(() => renderRoom(media));
      resizeObserver.observe(media);
    }
  }

  function scan(root = document) {
    if (root.matches?.(selector)) setup(root);
    root.querySelectorAll?.(selector).forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  } else {
    scan();
  }

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1) scan(node);
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
